<template>
  <div class="container" id="youtube">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-left">
                <a>
                  <router-link to="/home">
                    <img class="image col-xs-3" id="home" src="@/assets/news/home.png" height="50" width="50" alt="" />
                  </router-link> 
                </a> 
              </div>
              <div class="card-body">
                <div class="row">
                      <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'MUSIC'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('MUSIC')" src="@/assets/youtube/music.png" height="80" width="80" alt="" />
                                </router-link> 
                            </a> 
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                            <figcaption class="caption" style="color:black">MUSIC</figcaption>
                            </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                              <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'TALKSHOW'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('TALKSHOW')" src="@/assets/youtube/talkshow.jpg" height="80" width="80" alt="" />
                                </router-link> 
                            </a> 
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                            <figcaption class="caption" style="color:black">TALK SHOW</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>  
                              <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'TV'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('TV')" src="@/assets/youtube/tv.png" height="80" width="80" alt="" />
                                </router-link> 
                            </a>
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">WORLD TV</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                            <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'DRAMA'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('DRAMA')" src="@/assets/youtube/drama.png" height="80" width="80" alt="" />
                                </router-link> 
                            </a>
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">DRAMA</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                            <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'FOOD'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('FOOD')" src="@/assets/youtube/food.png" height="80" width="80" alt="" />
                                </router-link> 
                            </a>
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">COOKING</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>                       
                            <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'ANIMATION'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('ANIMATION')" src="@/assets/youtube/animation.png" height="80" width="80" alt="" />
                                </router-link> 
                            </a>
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">ANIMATION</figcaption>
                          </figure>
                        </div>

                        <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 box">
                          <figure>
                            <a>
                                <router-link :to="{ name: 'Vedio', params: {channel:'GAME'} }" >
                                  <img class="image col-xs-3" id="news" @click="selected('GAME')" src="@/assets/youtube/game.png" height="80" width="80" alt="" />
                                </router-link> 
                            </a>
                            <figcaption class="caption" style="color:black">&nbsp</figcaption>
                              <figcaption class="caption" style="color:black">GAME</figcaption>
                          </figure>
                        </div>   
                                       
                </div>
              </div>

              <div class="card-footer text-center">
                <small>Welcome to WeWaMart.</small>
              </div>
            </div>
          </div>
        </div>
  </div>

 </template> 

<script>

export default {
  name: 'youtube',
  methods: {
    selected: function(e){
      //alert ('The channel: ' + e);
      this.$store.commit('change', e);
      //alert('State: ' + this.$store.getters.channel );
    }
 }
} 
</script>

<style scoped>
    body {
      padding: 2rem 0;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1rem;
    }

    .temp-format {
      float: right;
      margin-bottom: 2rem;
      
      button {
        width: auto;
      }
    }

    .weather-details {
      clear: both;
    }

    .weather-temperature {
      font-size: 3rem;
    }

    .icon {
      font-size: 3rem;  
      margin-bottom: 1rem;
    }
//23-Dec, This is a box for providing a more space between icons.
.box{
  box-model: border-box;
  border: 15px solid transparent;
  background-clip:padding-box;
  box-sizing: content-box;  
  width: 120px;  //from 300px
  height: 150px;
  padding: 30px;  
  border: thin black solid;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: auto
}
figure {
  float: center;
  width: 100%;
  text-align: center;
  font-style: italic;
  font-weight: bold;
  font-size: smaller;
  text-indent: 0;
  border: thin black solid;
  margin: 0.5em;
  padding: 1.5em;
} 

</style>



// WEBPACK FOOTER //
// src/components/youtube.vue